/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React from 'react';
import Lottie from 'react-lottie';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';

import * as noResults from 'assets/animations/no-results.json';
import * as noResultsStatic from '../../assets/animations/no-results-static.json';
import * as noReports from '../../assets/animations/no-reports.json';
import * as noReportsStatic from '../../assets/animations/no-reports-static.json';
import * as weChanging from '../../assets/animations/we-changing.json';
import * as weChangingStatic from '../../assets/animations/we-changing-static.json';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: transparent;
`;

export type Img = 'no-results' | 'no-reports' | 'we-changing';

export interface Props {
  isAnimated?: boolean;
  width?: string;
  height?: string;
  type: Img;
  text?: string;
}

const chooseImg = (type: Img, isAnimated = true) => {
  switch (type) {
    case 'no-results':
      if (!isAnimated) return noResultsStatic;
      return noResults;
    case 'no-reports':
      if (!isAnimated) return noReportsStatic;
      return noReports;
    case 'we-changing':
      if (!isAnimated) return weChangingStatic;
      return weChanging;
    default:
      return noResults;
  }
};

const Animation = ({
  isAnimated = true,
  width = '100%',
  height = '100%',
  type = 'no-results',
  text,
}: Props) => {
  const imgUrl = chooseImg(type, isAnimated);
  const defaultOptions = {
    loop: isAnimated,
    autoplay: true,
    // @ts-ignore
    animationData: imgUrl.default,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <Container>
      <Lottie
        options={defaultOptions}
        height={height}
        width={width}
        isStopped={false}
        isPaused={false}
      />
      {text && <Typography variant="copy1">{text}</Typography>}
    </Container>
  );
};

export default Animation;
